import { AppProps, StateSlice } from "./app";
import { FEATURE_FLAG_NAMES } from "../../constants";

export type FeatureFlagsProps = {
  featureFlags: {
    diningAgentEnabled?: boolean;
    loading?: boolean;
    error?: Error;
  };
};

export type FeatureFlagsState = FeatureFlagsProps & {
  featureFlags: {
    fetchDiningAgent: () => Promise<void>;
    setDiningAgentEnabled: (enabled: boolean) => void;
    setLoading: (loading: boolean) => void;
    setError: (error?: Error) => void;
  };
};

export const defaultFeatureFlagsProps: FeatureFlagsProps = {
  featureFlags: {
    diningAgentEnabled: false,
    loading: false,
  },
};

export const createFeatureFlagsState: (
  props?: Partial<AppProps>,
) => StateSlice<FeatureFlagsState> = (props) => (set, get) => ({
  featureFlags: {
    ...defaultFeatureFlagsProps.featureFlags,
    ...props?.featureFlags,
    setDiningAgentEnabled: (diningAgentEnabled: boolean) =>
      set(
        (state) => ({
          ...state,
          featureFlags: { ...state.featureFlags, diningAgentEnabled },
        }),
        false,
        { type: "featureFlags.setDiningAgentEnabled", diningAgentEnabled },
      ),
    setLoading: (loading: boolean) =>
      set(
        (state) => ({
          ...state,
          featureFlags: { ...state.featureFlags, loading },
        }),
        false,
        { type: "featureFlags.setLoading", loading },
      ),
    setError: (error?: Error) =>
      set(
        (state) => ({
          ...state,
          featureFlags: { ...state.featureFlags, error },
        }),
        false,
        { type: "featureFlags.setError", error },
      ),
    fetchDiningAgent: async () => {
      const {
        client,
        featureFlags: { setDiningAgentEnabled, setLoading, setError },
      } = get();

      setLoading(true);
      try {
        if (client) {
          const hasAccess = await client.hasAccessToFeature(FEATURE_FLAG_NAMES.diningAgent);
          setDiningAgentEnabled(hasAccess === true);
          setError(undefined);
        } else {
          setDiningAgentEnabled(false);
          setError(new Error("client is not defined"));
        }
      } catch (error) {
        setDiningAgentEnabled(false);
        setError(error as Error);
      } finally {
        setLoading(false);
      }
    },
  },
});
